<template>
  <UISkeletonBase class="min-h-4 rounded" />
</template>
<script setup lang="ts">
import UISkeletonBase from '@booking-portal/modules/ui/skeletons/components/UISkeletonBase.vue';
</script>
